import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import theme from '../theme';
import { Card, Money, Spinner, StatusBadge, Pagination, Empty, Button, Select } from '../components/common';

export default function Payments() {
  const navigate = useNavigate();
  const [payments, setPayments] = useState(null);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);

  const load = (p, s) => {
    const params = `?page=${p}&limit=20${s ? `&status=${s}` : ''}`;
    api.get(`/payments${params}`).then(setPayments).catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => { load(1, ''); }, []);

  const handlePageChange = (p) => { setPage(p); load(p, status); };
  const handleStatusChange = (e) => { setStatus(e.target.value); setPage(1); load(1, e.target.value); };

  if (loading) return <div style={{ textAlign: 'center', padding: '60px' }}><Spinner size={32} /></div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
        <h1 style={{ fontSize: '20px', margin: 0 }}>Payments</h1>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <Select value={status} onChange={handleStatusChange} label="" style={{ marginBottom: 0, width: '160px' }}>
            <option value="">All statuses</option>
            <option value="INITIATED">Initiated</option>
            <option value="VALIDATED">Validated</option>
            <option value="PENDING_APPROVAL">Pending Approval</option>
            <option value="SUBMITTED">Submitted</option>
            <option value="SETTLED">Settled</option>
            <option value="FAILED">Failed</option>
          </Select>
          <Button variant="accent" onClick={() => navigate('/payments/new')}>New payment</Button>
        </div>
      </div>

      {payments?.data?.length > 0 ? (
        <Card style={{ padding: 0, overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', minWidth: '640px' }}>
            <thead>
              <tr style={{ background: theme.colors.bgAlt }}>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Reference</th>
                <th style={thStyle}>Beneficiary</th>
                <th style={thStyle}>Scheme</th>
                <th style={{ ...thStyle, textAlign: 'right' }}>Amount</th>
                <th style={thStyle}>Status</th>
              </tr>
            </thead>
            <tbody>
              {payments.data.map(p => (
                <tr key={p.id} onClick={() => navigate(`/payments/${p.id}`)} style={{ cursor: 'pointer' }}>
                  <td style={tdStyle}>{new Date(p.createdAt).toLocaleDateString('en-GB')}</td>
                  <td style={tdStyle}>{p.reference}</td>
                  <td style={tdStyle}>{p.beneficiary?.name || '-'}</td>
                  <td style={tdStyle}>{p.scheme}</td>
                  <td style={{ ...tdStyle, textAlign: 'right' }}><Money amount={p.amount} currency={p.currency} /></td>
                  <td style={tdStyle}><StatusBadge status={p.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination page={page} pages={payments?.pages || 1} onChange={handlePageChange} />
        </Card>
      ) : (
        <Empty message="No payments found" />
      )}
    </div>
  );
}

const thStyle = { padding: '10px 16px', textAlign: 'left', fontWeight: 600, fontSize: '12px', color: theme.colors.textMuted, borderBottom: `1px solid ${theme.colors.border}` };
const tdStyle = { padding: '12px 16px', borderBottom: `1px solid ${theme.colors.borderLight}` };
